import { Box, Text } from '@chakra-ui/react';
import { FC, ReactNode } from 'react';
import { ErrorBoundary } from 'react-error-boundary';

interface JournalEntryErrorBoundaryProps {
  children: ReactNode;
}

const EntryErrorFallback: FC = () => (
  <Box
    borderRadius="md"
    borderWidth="1px"
    borderColor="border.default"
    bg="surface.card"
    p={3}
    data-testid="journal-entry-error-fallback"
  >
    <Text fontSize="sm" color="text.muted">
      Couldn&apos;t display this entry.
    </Text>
  </Box>
);

/**
 * Isolates a single journal entry so a render failure does not blank the timeline.
 */
export const JournalEntryErrorBoundary: FC<JournalEntryErrorBoundaryProps> = ({
  children,
}) => (
  <ErrorBoundary fallback={<EntryErrorFallback />}>{children}</ErrorBoundary>
);
